<template>
  <div
    class="viz-tooltip"
    v-if="getMainVizTooltip && getMainVizTooltipPos"
    :style="{
      top: getMainVizTooltipPos.y + 'px',
      left: getMainVizTooltipPos.x + 'px'
    }"
  >
    <div
      class="viz-tooltip__container"
      :style="{
        left: orientationRight ? 'auto' : 0,
        right: orientationRight ? 0 : 'auto',
        bottom: orientationTop ? 'auto' : 0,
        top: orientationTop ? 0 : 'auto'
      }"
    >
      <div class="viz-tooltip__first-child">
        <span v-for="(el, elIndex) in content.path" :key="el"
          >{{ el }}{{ elIndex < content.path.length - 1 ? "/" : "" }}</span
        >
      </div>
      <div class="viz-tooltip__last-child">
        <svgicon
          class="icon-picture"
          icon="icon-picture"
          width="20"
          height="20"
          color="#000000"
          v-if="this.getFilterViz === 'images'"
        ></svgicon>

        <svgicon
          class="icon-versi"
          icon="icon-versi"
          width="20"
          height="20"
          color="#000000"
          v-else
        ></svgicon>
        {{ getTooltipContent() }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import "../../compiled-icons/icon-picture";
import "../../compiled-icons/icon-versi";

import _ from "lodash";
export default {
  computed: {
    orientationRight() {
      return (
        this.content.path.join("").length * 10 >
        window.innerWidth - this.getMainVizTooltipPos.x
      );
    },
    orientationTop() {
      return this.getMainVizTooltipPos.y < 90;
    },
    content() {
      if (!this.getMainVizTooltip) {
        return null;
      } else {
        let ancestors = this.getMainVizTooltip.ancestors();
        let value = 0;

        if (this.getFilterViz === "versi") {
          let leaves = this.getMainVizTooltip.leaves();
          value = _.sumBy(
            leaves,
            o => o.data.metadata.al_verso - o.data.metadata.dal_verso + 1
          );
        } else {
          let leaves = this.getMainVizTooltip.leaves();
          value = _.sumBy(leaves, o => {
            if (o.data.metadata.images && o.data.metadata.images.length > 0) {
              return o.data.metadata.images.filter(
                o => o.downloaded !== "false"
              ).length;
            } else {
              return 0;
            }
          });
        }
        return {
          path: ancestors
            .reverse()
            .map(d => d.data.name)
            .slice(1),
          value
        };
      }
    },
    label() {
    //  let labels = this.$ml.get("dataviz.filter.options");
      let labels = this.$ml.get("dataviz.tooltip");
      return labels[this.getFilterViz];
    },
    ...mapGetters(["getMainVizTooltip", "getMainVizTooltipPos", "getFilterViz"])
  },
  methods: {
    getTooltipContent() {
      let c = this.content.value.toLocaleString(
        this.$ml.current === "ita" ? "it-IT" : "en-US"
      );

      return c + " " + this.label;
    }
  }
};
</script>
<style lang="scss" scoped>
.viz-tooltip {
  width: 0;
  height: 0;
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 2;
  pointer-events: none;
  transition: top 0.1s ease, left 0.1s ease;
  @include DidaL;
  &__container {
    position: absolute;
    margin: 10px 0;
    left: 0;
    min-width: 160px;
    height: 52px;
  }
  &__first-child {
    height: 50%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    // gap: 10px;
    padding: 5px 12px;
    -webkit-backdrop-filter: blur(20px);
    border: solid 1px $white;
    background-color: rgba(255, 255, 255, 0.7);
    color: rgba(0, 0, 0, 1);

    span {
      opacity: 0.5;
      flex-shrink: 0;
      white-space: nowrap;
      &:last-of-type {
        opacity: 1;
      }
    }
  }
  &__last-child {
    height: 50%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    padding: 5px 12px;
    border: solid 1px $white;
    background-color: $white;
    white-space: nowrap;
  }
}
</style>
